export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Toolbar.components.ToolbarDesks.Exports'
export const PDF_EXPORT_DETAIL_SMALL = 'small'
export const PDF_EXPORT_DETAIL_BIG = 'big'
export const PDF_EXPORT_DETAIL_COMPLETE = 'complete'

export const LISTS = {
    DISCLAIMER: 'disclaimer',
}

export const OFU_STANDARD = '0601'

export const BLOCK_TYPE = {
    BASIC: 'basic',
    EXTENDED: 'extended',
}
